<template>
    <div class="tnc">
        <h1 class="title">{{title}}</h1>
        <div class="content"><div v-html="content"></div></div>
    </div>
</template>
<script>

import { getLangConfig } from '../business';

export default {
    name: 'tnc',
    props: [],
    components: {},
    data: function() {
        return {
            title: "-",
            content: ""
        }
    },
    created() {
        let index = this.$route.query.index * 1;
        this.title = `规则说明${index}-${this.$route.query.lang}`;
        this.content = "";
        getLangConfig().then(({ lang, langObj }) => {
            this.content = langObj[`coupon_${index+1}_tnc`];
            this.title = langObj.rule_tips;
        });
        window.scrollTo(0, 0);
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
    @rem: 200rem;
    .tnc {
        text-align: left;
        font-size: 24/@rem;
        color: #fff;
        line-height: 40/@rem;
    }
    .title {
        text-align:center;
        font-size: 34/@rem;
        margin: 80/@rem 0 20/@rem 0;
    }
    .content {
        margin: 40/@rem;
        font-family: "微软雅黑"
    }
    
</style>
